<!-- Responsibility: Implement player profile effects behavior for the ui/components surface.
Scope: Owns ui/components concerns only; cross-surface orchestration is excluded. -->

<player-profile-effects>
  <section class="pp-section" if={ props.model && props.model.hasStatusEffects }>
    <h5 class="pp-section-title">STATUS EFFECTS</h5>
    <div class="pp-effects">
      <span
        each={ fx in props.model.activeEffects.items }
        class="pp-fx active"
        role="button"
        tabindex="0"
        aria-label={ `Open active effect ${fx.label}` }
        onclick={ () => props.onOpen && props.onOpen(fx, true) }
        onkeydown={ (e) => props.onActivateKey && props.onActivateKey(e, () => props.onOpen && props.onOpen(fx, true)) }
      >
        { fx.text }
      </span>
      <span
        each={ fx in props.model.dormantEffects.items }
        class="pp-fx dormant"
        role="button"
        tabindex="0"
        aria-label={ `Open dormant effect ${fx.label}` }
        onclick={ () => props.onOpen && props.onOpen(fx, false) }
        onkeydown={ (e) => props.onActivateKey && props.onActivateKey(e, () => props.onOpen && props.onOpen(fx, false)) }
      >
        { fx.text }
      </span>
    </div>
    <p if={ props.model.activeEffects.overflow > 0 } class="pp-overflow-note">+{ props.model.activeEffects.overflow } more active effects hidden.</p>
    <p if={ props.model.dormantEffects.overflow > 0 } class="pp-overflow-note">+{ props.model.dormantEffects.overflow } more dormant effects hidden.</p>
  </section>

  <style>
    .pp-section { animation: section-in 0.5s ease both; }
    .pp-section-title { color: var(--text-dim); font-size: var(--space-sm); letter-spacing: 0.25em; margin: 0 0 1.25rem; border-bottom: 1px solid var(--border); padding-bottom: var(--space-xs); }
    .pp-effects { display: flex; flex-wrap: wrap; gap: 0.6rem; }
    .pp-overflow-note { margin: var(--space-xs) 0 0; color: color-mix(in srgb, var(--text-muted) var(--alpha-high), #dbe8ff); font-size: var(--space-sm); letter-spacing: 0.03em; }
    .pp-fx {
      font-size: var(--space-sm); letter-spacing: 0.04em; font-weight: 700; padding: var(--space-xs) var(--space-sm); border-radius: 62.4375rem; border: 1px solid var(--border); background: linear-gradient(165deg, #04070f, #0a1321); cursor: pointer; transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .pp-fx:hover { transform: translateY(-1px) scale(1.02); }
    .pp-fx.active {
      color: color-mix(in srgb, var(--gold) var(--alpha-high), var(--text-prose)); border-color: color-mix(in srgb, var(--gold) 40%, transparent);
      background: radial-gradient(circle at var(--alpha-glow) var(--alpha-low), color-mix(in srgb, var(--gold) var(--alpha-low), transparent), transparent var(--alpha-focus)), linear-gradient(165deg, color-mix(in srgb, var(--gold) var(--alpha-glow), #060913), #0b1320);
      box-shadow: 0 0 0 1px rgba(251,191,36,0.14); animation: fx-pulse 2.5s ease-in-out infinite;
    }
    .pp-fx.dormant { color: var(--text-dim); border-color: color-mix(in srgb, #64748b var(--alpha-mid), var(--border)); background: linear-gradient(165deg, rgba(51,65,85,0.28), rgba(10,15,24,0.86)); opacity: 0.82; }

  </style>
</player-profile-effects>
